import React from "react";
import { useNavigate } from "react-router-dom";
import "./AdminPanel.css";

const AdminPanel = () => {
  const navigate = useNavigate();

  const sections = [
    {
      label: "Inventory Management",
      icon: "🚗",
      actions: [
        { label: "Add Car", icon: "➕", route: "/InventoryAddForm" },
        { label: "Delete Car", icon: "🗑️", route: "/InventoryDeleteForm" },
        { label: "View Cars", icon: "👁️", route: "/Inventory" },
        { label: "Update Car", icon: "✏️", route: "/InventoryUpdateForm" },
        { label: "Feature Car", icon: "⭐", route: "/InventoryFeatureForm" }, // ✅ Added Feature Car
      ],
    },
    {
      label: "Banner Management",
      icon: "🖼️",
      actions: [
        { label: "Add Banner", icon: "➕", route: "/add-banner" },
        { label: "Delete Banner", icon: "🗑️", route: "/delete-banner" },
        { label: "View Banners", icon: "👁️", route: "/view-banners" },
        { label: "Update Banner", icon: "✏️", route: "/update-banner" },
      ],
    },
    {
      label: "Invoices",
      icon: "🧾",
      actions: [
        { label: "Make Invoice", icon: "🧾", route: "/admin/create-invoice" },
      ],
    },
  ];

  return (
    <div className="admin-wrapper">
      <div className="admin-panel">
        <h1 className="admin-title">Admin Dashboard</h1>

        <div className="admin-sections">
          {sections.map((section, idx) => (
            <div key={idx} className="admin-section-box">
              <div className="admin-section-icon">{section.icon}</div>
              <h2 className="admin-section-title">{section.label}</h2>
              <div className="admin-sub-actions">
                {section.actions.map((action, index) => (
                  <div
                    key={index}
                    className="admin-action-box"
                    onClick={() => navigate(action.route)}
                  >
                    <div className="admin-icon">{action.icon}</div>
                    <div className="admin-label">{action.label}</div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AdminPanel;
